import CustomDownloadComponent from "../../../components/FileDownload/CustomDownloadComponent";
import UploadedDocuments from "../../../components/UploadedDocuments/UploadedDocuments";
import { UploadedDocumentData } from "../UserData";

const DisbursementDeatils = ({ FloorCaseDetails, GetOwnerType }) => {
    const AddLabelToFile = (arr, value) => {
        //console.log("Document", value);
        return {
            label: value,
            files: arr,
        };
    };

    const VehicleInfo = FloorCaseDetails?.vehicleInfo;
    const DisbursemnetData = FloorCaseDetails?.cart[0]?.agent?.disbursement;
    //console.log("DisbursemnetData", FloorCaseDetails, DisbursemnetData)



    return (
        <section>
            {/* Application Preview */}
            <div className="preview-list-block">
                <div className="preview-list-group">
                    <div className="preview-list">
                        <h3>Floor Start Date:</h3>
                        <p>{DisbursemnetData?.flooring_start_date}</p>
                    </div>
                    <div className="preview-list">
                        <h3>Disbursement Date:</h3>
                        <p>{DisbursemnetData?.disbursement_date}</p>
                    </div>
                    <div className="preview-list">
                        <h3>Remarks:</h3>
                        <p>{DisbursemnetData?.remarks}</p>
                    </div>
                </div>
            </div>

            {/* Uploaded Documents */}
            <div className="preview-list-block">
                <div className="download-block">
                    <h2 className="preview-subheading">Document (s) Uploaded</h2>
                    <CustomDownloadComponent
                        type="Flooring-Disbursement-Details"
                        appId={FloorCaseDetails?.vehicleInfo?.id}
                        formType={"disbursement_doc"}
                    />
                </div>
                <div className="preview-list-group">
                    {FloorCaseDetails?.disbursement_doc?.length > 0 && (
                        <UploadedDocuments
                            documents={AddLabelToFile(
                                FloorCaseDetails?.disbursement_doc,
                                "Disbursement Document(s)"
                            )}
                        />
                    )}
                </div>
            </div>
        </section>
    );
};
export default DisbursementDeatils;
